import { render, staticRenderFns } from "./StudentAward.vue?vue&type=template&id=4ff0bd76&scoped=true&"
import script from "./StudentAward.vue?vue&type=script&lang=js&"
export * from "./StudentAward.vue?vue&type=script&lang=js&"
import style0 from "./StudentAward.vue?vue&type=style&index=0&id=4ff0bd76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0bd76",
  null
  
)

export default component.exports